<!-- src/views/Drone/Drone.vue -->
<template>
  <div class="drone-page">
    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="header-content">
        <div class="logo">
          <div class="logo-icon">✈</div>
          <span>全国青少年国防素养大赛智能无人系统应用赛线上答题系统</span>
        </div>

        <!-- 移动端菜单按钮 -->
        <div class="menu-toggle" @click="toggleMenu">
          <i class="fa fa-bars"></i>
        </div>

        <!-- 导航菜单 -->
        <ul class="nav-menu" :class="{ show: menuShow }">
          <li
            class="nav-item"
            :class="{ active: activePage === 'index' }"
            @click="switchPage('index')"
          >首页</li>
          <li
            class="nav-item"
            :class="{ active: activePage === 'question-bank' }"
            @click="switchPage('question-bank')"
          >题库</li>
          <li
            class="nav-item"
            :class="{ active: activePage === 'answer' }"
            @click="switchPage('answer')"
          >练习</li>
          <li
            class="nav-item"
            :class="{ active: activePage === 'exam' }"
            @click="switchPage('exam')"
          >模拟考核</li>
          <li
            class="nav-item"
            :class="{ active: activePage === 'knowledge' }"
            @click="switchPage('knowledge')"
          >学习资料</li>
              <li
            class="nav-item"
            :class="{ active: activePage === 'ai-assistant' }"
            @click="switchPage('ai-assistant')"
          >AI问答</li>
          <li
            class="nav-item"
            :class="{ active: activePage === 'self-study' }"
            @click="switchPage('self-study')"
          >个人中心</li>
      
        </ul>

        <div class="nav-right">
          <router-link to="/" class="back-home-btn">
            <i class="fa fa-home"></i> 军招报名系统
          </router-link>
        </div>
      </div>
    </header>

    <!-- 主内容区域 -->
    <div class="container">
      <div class="main-content">
        <IndexPage v-if="activePage === 'index'" />
        <QuestionBank v-if="activePage === 'question-bank'" />
        <AnswerPage v-if="activePage === 'answer'" />
        <ExamPage v-if="activePage === 'exam'" />
        <KnowledgePage v-if="activePage === 'knowledge'" />
        <SelfStudy v-if="activePage === 'self-study'" />
        <AiAssistant v-if="activePage === 'ai-assistant'" />
      </div>
    </div>

    <!-- 底部 -->
    <footer class="footer">
      <p>全国青少年国防素养大赛智能无人系统应用赛线上答题系统 - 专业、全面、智能的无人机学习平台</p>
    </footer>
  </div>
</template>

<script>
import IndexPage from './pages/IndexPage.vue';
import QuestionBank from './pages/QuestionBank.vue';
import AnswerPage from './pages/AnswerPage.vue';
import ExamPage from './pages/ExamPage.vue';
import KnowledgePage from './pages/KnowledgePage.vue';
import SelfStudy from './pages/SelfStudy.vue';
import AiAssistant from './pages/AiAssistant.vue';

export default {
  name: "Drone",
  components: {
    IndexPage,
    QuestionBank,
    AnswerPage,
    ExamPage,
    KnowledgePage,
    SelfStudy,
    AiAssistant
  },
  data() {
    return {
      activePage: 'index',
      menuShow: false
    };
  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
    switchPage(page) {
      this.activePage = page;
      this.menuShow = false;
      window.scrollTo(0, 0);
    },
    toggleMenu() {
      this.menuShow = !this.menuShow;
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.drone-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* 顶部导航栏 */
.header {
  background: linear-gradient(135deg, #1a5f7a 0%, #159895 100%);
  padding: 0 20px;
  box-shadow: 0 2px 10px rgba(22, 160, 133, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-content {
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 70px;
  justify-content: space-between;
  position: relative;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: opacity 0.3s;
}

.logo:hover {
  opacity: 0.9;
}

.logo-icon {
  font-size: 26px;
  color: #fff;
  flex-shrink: 0;
}

.logo span {
  font-size: 15px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 0.5px;
  line-height: 1.3;
  white-space: nowrap;
}

.menu-toggle {
  display: none;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
  padding: 8px;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 6px;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 0 10px;
}

.nav-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.back-home-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  padding: 8px 14px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s;
  white-space: nowrap;
}

.back-home-btn:hover {
  background: rgba(255, 255, 255, 0.25);
}

.back-home-btn i {
  font-size: 16px;
}

.nav-item {
  color: rgba(255, 255, 255, 0.85);
  padding: 10px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  white-space: nowrap;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.nav-item.active {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
  font-weight: 500;
}

.container {
  flex: 1;
  padding: 30px 20px;
  margin-top: 70px;
}

.main-content {
  max-width: 1440px;
  margin: 0 auto;
}

.footer {
  background: #1a5f7a;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  padding: 20px;
  font-size: 14px;
  margin-top: auto;
}

/* ===================== 移动端 (< 768px) ===================== */
@media (max-width: 767px) {
  .header {
    padding: 0 12px;
  }

  .header-content {
    height: 60px;
  }

  .menu-toggle {
    display: block;
  }

  .nav-menu {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    background: linear-gradient(135deg, #1a5f7a 0%, #159895 100%);
    flex-direction: column;
    padding: 12px 0;
    gap: 4px;
    display: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .nav-menu.show {
    display: flex;
  }

  .nav-item {
    width: 100%;
    text-align: center;
    padding: 14px;
    font-size: 15px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logo {
    max-width: calc(100% - 80px);
  }

  .logo span {
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .logo-icon {
    font-size: 22px;
  }

  .back-home-btn {
    display: none;
  }

  .container {
    padding: 15px 12px;
    margin-top: 60px;
  }

  .footer {
    padding: 15px 12px;
    font-size: 12px;
  }
}

/* ===================== 平板端 (768px ~ 1024px) ===================== */
@media (min-width: 768px) and (max-width: 1024px) {
  .header-content {
    max-width: 100%;
  }

  .nav-menu {
    gap: 2px;
    padding: 0 5px;
  }

  .nav-item {
    padding: 8px 10px;
    font-size: 13px;
  }

  .back-home-btn {
    padding: 6px 10px;
    font-size: 13px;
  }

  .logo span {
    font-size: 13px;
  }

  .container {
    padding: 25px 15px;
  }

  .main-content {
    max-width: 95%;
  }
}

/* ===================== 桌面端 (≥ 1024px) ===================== */
@media (min-width: 1025px) {
  .nav-menu {
    display: flex;
  }
}

/* ===================== 超宽屏 (> 1440px) ===================== */
@media (min-width: 1441px) {
  .header-content {
    max-width: 1440px;
  }

  .main-content {
    max-width: 1440px;
  }

  .container {
    padding: 40px 60px;
  }
}

/* ===================== 触摸设备优化 ===================== */
@media (hover: none) and (pointer: coarse) {
  .nav-item:active {
    background: rgba(255, 255, 255, 0.3);
  }

  .back-home-btn:active {
    background: rgba(255, 255, 255, 0.3);
  }
}

/* ===================== 横屏模式适配 ===================== */
@media (max-height: 500px) and (orientation: landscape) {
  .header-content {
    height: 50px;
  }

  .nav-menu {
    top: 50px;
    max-height: 60vh;
    overflow-y: auto;
  }

  .container {
    margin-top: 50px;
    padding: 10px;
  }
}

/* ===================== 视网膜屏幕适配 ===================== */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .logo-icon,
  .nav-item {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}
</style>
